import { Component, Input, OnInit, EventEmitter, Output } from '@angular/core';
import { environment } from '@base/environments/environment';
import { Constants } from '@base/src/app/models/constants';
import { QRButton } from '@base/src/app/models/qr-button.model';

@Component({
  selector: 'app-block-edit-different-module',
  templateUrl: './block-edit-different-module.component.html',
  styleUrls: ['./block-edit-different-module.component.scss'],
})
export class BlockEditDifferentModuleComponent implements OnInit {
  @Input() type: string = '';
  @Output() close: EventEmitter<boolean> = new EventEmitter();

  public readonly TYPE_DELETE = 'delete';
  public readonly TYPE_DRAFT = 'draft';
  public readonly TYPE_RENDITION = 'rendition';

  oldFrontUrl = environment.oldFrontUrl;

  buttonClose: QRButton = {
    hierarchy: QRButton.HIERARCHY_3,
    size: QRButton.SIZE_MEDIUM,
    icon: Constants.ICONS.CLOSE,
    iconOnly: true,
  };
  buttonRenditions: QRButton = {
    hierarchy: QRButton.HIERARCHY_1,
    size: QRButton.SIZE_MEDIUM,
    viewValue: 'Ir al módulo antiguo',
  };

  buttonDrafts: QRButton = {
    hierarchy: QRButton.HIERARCHY_3,
    size: QRButton.SIZE_MEDIUM,
    viewValue: 'Ir a borradores',
  };

  message = '';

  ngOnInit(): void {
    switch (this.type) {
      case this.TYPE_DRAFT:
        this.message =
          'El borrador fue creado en el módulo antiguo y no puede ser editado aquí. Dirígete al módulo correspondiente para poder realizar la edición.';
        break;
      case this.TYPE_RENDITION:
        this.message =
          'La rendición fue creada en el módulo antiguo y no puede ser editada aquí. Dirígete al módulo correspondiente para poder realizar la edición.';
        break;
      case this.TYPE_DELETE:
        this.message =
          'No se puede proceder con la anulación de esta rendición, ya que pertenece al módulo antiguo. Por favor, realiza esta acción en el módulo donde fue creada.';
        break;
    }
  }

  onRelocation() {
    location.href = this.oldFrontUrl + '/rendicion';
  }
}
